import { useContext, useEffect } from 'react';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { ChainlitContext } from '@chainlit/react-client';
import { 
  uiSettingsState, 
  uiSettingsLoadingState, 
  uiSettingsErrorState,
  uiSettingsInitializedSelector
} from '@/state/uiSettings';
import { UISettingsService } from '@/services/uiSettingsService';

/**
 * Hook to initialize UI settings once at app startup.
 * Should be called from the root App component.
 */
export const useInitializeUISettings = () => {
  const apiClient = useContext(ChainlitContext);
  const setSettings = useSetRecoilState(uiSettingsState);
  const setLoading = useSetRecoilState(uiSettingsLoadingState);
  const setError = useSetRecoilState(uiSettingsErrorState);
  const isInitialized = useRecoilValue(uiSettingsInitializedSelector);

  useEffect(() => {
    // Only initialize if we have an API client and haven't initialized yet
    if (!apiClient?.httpEndpoint || isInitialized) {
      return;
    }

    UISettingsService.initialize(
      apiClient.httpEndpoint,
      setSettings,
      setLoading,
      setError
    ).catch((error) => {
      console.error('[useInitializeUISettings] Initialization failed:', error);
    });
  }, [apiClient?.httpEndpoint, isInitialized, setSettings, setLoading, setError]);

  return {
    isInitialized
  };
};